<!-- src/views/DiagnosticoExpress.vue -->
<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Header Section -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-yellow-500 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-yellow-600 tracking-widest">Diagnósticos EXPRESS</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Diagnósticos EXPRESS
          <span class="px-2 sm:px-3 py-0.5 bg-yellow-100 dark:bg-yellow-900/40 text-yellow-600 dark:text-yellow-300 text-xs sm:text-sm font-black rounded-lg border border-yellow-200 dark:border-yellow-800">
            {{ diagnosticos.length }}
          </span>
        </h1>
      </div>
      <div class="flex items-center gap-1 sm:gap-2 w-full sm:w-auto flex-wrap">
        <button @click="vistaActual = 'todos'" class="btn" :class="vistaActual === 'todos' ? 'btn-primary-yellow' : 'btn-outline-yellow'">
          <Icon icon="mdi:format-list-bulleted" />
          <span class="hidden sm:inline">Todos</span>
        </button>
        <button @click="vistaActual = 'hoy'" class="btn" :class="vistaActual === 'hoy' ? 'btn-primary-yellow' : 'btn-outline-yellow'">
          <Icon icon="mdi:calendar-today" />
          <span class="hidden sm:inline">Hoy</span>
        </button>
        <button @click="vistaActual = 'semanal'" class="btn" :class="vistaActual === 'semanal' ? 'btn-primary-yellow' : 'btn-outline-yellow'">
          <Icon icon="mdi:calendar-week" />
          <span class="hidden sm:inline">Semanal</span>
        </button>
        <button @click="vistaActual = 'mensual'" class="btn" :class="vistaActual === 'mensual' ? 'btn-primary-yellow' : 'btn-outline-yellow'">
          <Icon icon="mdi:calendar-month" />
          <span class="hidden sm:inline">Mensual</span>
        </button>
        <button @click="vistaActual = 'estadisticas'" class="btn" :class="vistaActual === 'estadisticas' ? 'btn-primary-yellow' : 'btn-outline-yellow'">
          <Icon icon="mdi:chart-bar" />
          <span class="hidden sm:inline">Estadísticas</span>
        </button>
      </div>
    </div>

    <!-- ============ VISTA: ESTADÍSTICAS CON GRÁFICOS ============ -->
    <template v-if="vistaActual === 'estadisticas'">
      <!-- Tarjetas de Estadísticas -->
      <div class="grid grid-cols-2 sm:grid-cols-5 gap-2 sm:gap-4 mb-3 sm:mb-5">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 hover:shadow-md transition-all">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">Total</p>
              <p class="text-lg sm:text-2xl font-black text-gray-900 dark:text-white">{{ diagnosticos.length }}</p>
            </div>
            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-100 dark:bg-yellow-900/30 rounded-xl flex items-center justify-center">
              <Icon icon="mdi:flash" class="text-yellow-600 text-lg sm:text-xl" />
            </div>
          </div>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 hover:shadow-md transition-all">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">Completados</p>
              <p class="text-lg sm:text-2xl font-black text-green-600 dark:text-green-400">{{ diagnosticosCompletados }}</p>
            </div>
            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-green-100 dark:bg-green-900/30 rounded-xl flex items-center justify-center">
              <Icon icon="mdi:check-circle" class="text-green-600 text-lg sm:text-xl" />
            </div>
          </div>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 hover:shadow-md transition-all">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">En Proceso</p>
              <p class="text-lg sm:text-2xl font-black text-blue-600 dark:text-blue-400">{{ diagnosticosEnProceso }}</p>
            </div>
            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center">
              <Icon icon="mdi:progress-clock" class="text-blue-600 text-lg sm:text-xl" />
            </div>
          </div>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 hover:shadow-md transition-all">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">Entregados</p>
              <p class="text-lg sm:text-2xl font-black text-purple-600 dark:text-purple-400">{{ diagnosticosEntregados }}</p>
            </div>
            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-purple-100 dark:bg-purple-900/30 rounded-xl flex items-center justify-center">
              <Icon icon="mdi:truck-delivery" class="text-purple-600 text-lg sm:text-xl" />
            </div>
          </div>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-4 hover:shadow-md transition-all">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-[8px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest">Monto Total</p>
              <p class="text-lg sm:text-2xl font-black text-rose-600 dark:text-rose-400">${{ totalMonto.toFixed(2) }}</p>
            </div>
            <div class="w-8 h-8 sm:w-10 sm:h-10 bg-rose-100 dark:bg-rose-900/30 rounded-xl flex items-center justify-center">
              <Icon icon="mdi:cash" class="text-rose-600 text-lg sm:text-xl" />
            </div>
          </div>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <!-- Gráfico de Barras -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
          <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest mb-3">Diagnósticos por Estado</h3>
          <div class="h-64 relative">
            <canvas ref="chartBarRef"></canvas>
          </div>
        </div>

        <!-- Gráfico de Dona -->
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
          <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest mb-3">Distribución de Estados</h3>
          <div class="h-64 relative flex items-center justify-center">
            <canvas ref="chartDoughnutRef"></canvas>
          </div>
        </div>
      </div>

      <!-- Gráfico de Líneas -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 mb-4">
        <h3 class="text-xs font-black text-gray-400 uppercase tracking-widest mb-3">Tendencia de Montos por Día</h3>
        <div class="h-64 relative">
          <canvas ref="chartLineRef"></canvas>
        </div>
      </div>

      <!-- Tabla Resumen de Estados -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                <th class="px-4 py-3 text-[10px] font-black text-gray-400 tracking-widest">Estado</th>
                <th class="px-4 py-3 text-[10px] font-black text-gray-400 tracking-widest text-center">Cantidad</th>
                <th class="px-4 py-3 text-[10px] font-black text-gray-400 tracking-widest text-center">Monto Total</th>
                <th class="px-4 py-3 text-[10px] font-black text-gray-400 tracking-widest text-center">Clasificación</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
              <tr v-if="cargando">
                <td colspan="4" class="px-4 py-8 text-center text-gray-400">Cargando...</td>
              </tr>
              <tr v-else-if="estadosResumen.length === 0">
                <td colspan="4" class="px-4 py-8 text-center text-gray-400">No hay datos para mostrar</td>
              </tr>
              <tr v-for="item in estadosResumen" :key="item.estado" class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                <td class="px-4 py-3 text-xs font-medium">
                  <div :class="getEstadoStyle(item.estado)" class="px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest text-center border shadow-sm inline-block">
                    {{ item.estado }}
                  </div>
                </td>
                <td class="px-4 py-3 text-xs font-black text-center text-gray-900 dark:text-white">{{ item.cantidad }}</td>
                <td class="px-4 py-3 text-xs font-black text-center text-rose-600 dark:text-rose-400">${{ item.monto.toFixed(2) }}</td>
                <td class="px-4 py-3 text-xs font-black text-center">
                  <span :class="item.clasificacion === 'COMPLETADO' ? 'text-green-600 dark:text-green-400' : item.clasificacion === 'EN PROCESO' ? 'text-blue-600 dark:text-blue-400' : 'text-purple-600 dark:text-purple-400'">
                    {{ item.clasificacion }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <!-- ============ VISTA: LISTA (Todos, Hoy, Semanal, Mensual) ============ -->
    <template v-else>
      <!-- Filters & Search -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-3 sm:p-5 mb-3 sm:mb-5 animate-fadeInUp">
        <div class="grid grid-cols-1 sm:grid-cols-12 gap-3 sm:gap-5 items-end">
          <div class="sm:col-span-7 lg:col-span-8">
            <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 tracking-widest mb-1 sm:mb-2 ml-1">Búsqueda Inteligente</label>
            <div class="relative group">
              <Icon icon="mdi:magnify" class="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg sm:text-2xl group-focus-within:text-yellow-500 transition-colors" />
              <input
                v-model="filtroBusqueda"
                type="text"
                placeholder="Buscar por orden, cliente, equipo o estado..."
                class="w-full pl-10 sm:pl-14 pr-3 sm:pr-4 py-2.5 sm:py-3 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-yellow-500 focus:bg-white dark:focus:bg-gray-700 rounded-xl transition-all duration-300 outline-none dark:text-white font-bold text-sm sm:text-base"
              />
            </div>
          </div>
          
          <div class="sm:col-span-3 lg:col-span-2">
            <label class="block text-[10px] sm:text-[11px] font-black text-gray-400 tracking-widest mb-1 sm:mb-2 ml-1">Clasificación</label>
            <select
              v-model="filtroClasificacion"
              class="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-gray-50 dark:bg-gray-900/50 border-2 border-gray-100 dark:border-gray-700 focus:border-yellow-500 rounded-xl font-black text-gray-800 dark:text-white outline-none transition-all appearance-none cursor-pointer text-sm sm:text-base"
            >
              <option value="TODOS">TODOS</option>
              <option value="COMPLETADO">COMPLETADO</option>
              <option value="EN_PROCESO">EN PROCESO</option>
              <option value="ENTREGADO">ENTREGADO</option>
            </select>
          </div>

          <div class="sm:col-span-2 lg:col-span-2">
            <button 
              @click="cargarSegunVista"
              class="w-full py-2.5 sm:py-3.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] sm:text-xs tracking-widest hover:bg-gray-200 dark:hover:bg-gray-600 transition-all flex items-center justify-center gap-2 border border-gray-200 dark:border-gray-600 shadow-sm"
            >
              <Icon icon="mdi:refresh" :class="{'animate-spin': cargando}" class="text-lg sm:text-xl" />
              <span class="hidden sm:inline">Refrescar</span>
              <span class="sm:hidden">Refrescar</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Tarjetas de Estadísticas (resumen rápido) -->
      <div class="grid grid-cols-2 sm:grid-cols-5 gap-2 sm:gap-4 mb-3 sm:mb-5" v-if="diagnosticos.length > 0">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-2 sm:p-3 hover:shadow-md transition-all">
          <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-widest">Total</p>
          <p class="text-lg sm:text-xl font-black text-gray-900 dark:text-white">{{ diagnosticos.length }}</p>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-2 sm:p-3 hover:shadow-md transition-all">
          <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-widest">Completados</p>
          <p class="text-lg sm:text-xl font-black text-green-600">{{ diagnosticosCompletados }}</p>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-2 sm:p-3 hover:shadow-md transition-all">
          <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-widest">En Proceso</p>
          <p class="text-lg sm:text-xl font-black text-blue-600">{{ diagnosticosEnProceso }}</p>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-2 sm:p-3 hover:shadow-md transition-all">
          <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-widest">Entregados</p>
          <p class="text-lg sm:text-xl font-black text-purple-600">{{ diagnosticosEntregados }}</p>
        </div>
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-2 sm:p-3 hover:shadow-md transition-all">
          <p class="text-[8px] sm:text-[9px] font-black text-gray-400 uppercase tracking-widest">Monto</p>
          <p class="text-lg sm:text-xl font-black text-rose-600">${{ totalMonto.toFixed(2) }}</p>
        </div>
      </div>

      <!-- Data Table -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-100">
        <!-- Versión Desktop -->
        <div class="hidden lg:block overflow-x-auto custom-scrollbar">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Orden</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Equipo / Problema</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Fecha</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Estado</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Monto</th>
                <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Clasificación</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
              <tr v-if="cargando" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
                <td colspan="7" class="px-5 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
              </tr>
              <tr v-if="!cargando && diagnosticosFiltrados.length === 0">
                <td colspan="7" class="px-5 py-16 text-center">
                  <div class="flex flex-col items-center opacity-30 select-none">
                    <Icon icon="mdi:database-off-outline" class="text-7xl mb-3" />
                    <h4 class="text-xl font-black text-gray-400 tracking-widest">No hay diagnósticos EXPRESS</h4>
                    <p class="text-sm text-gray-400 mt-2" v-if="filtroClasificacion && filtroClasificacion !== 'TODOS'">
                      Filtro actual: <span class="font-bold">{{ filtroClasificacion }}</span>
                    </p>
                    <p class="text-sm text-gray-400 mt-1" v-if="filtroBusqueda">
                      Búsqueda: <span class="font-bold">{{ filtroBusqueda }}</span>
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-for="item in paginatedDiagnosticos" :key="item.idRecepcionEquipo" class="hover:bg-yellow-50/30 dark:hover:bg-gray-700/30 transition-all group">
                <td class="px-5 py-4">
                  <span class="px-2.5 py-1 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-lg font-black text-xs border border-yellow-100 dark:border-yellow-800">
                    #{{ item.numeroOrden }}
                  </span>
                </td>
                <td class="px-5 py-4">
                  <div class="text-left">
                    <p class="font-black text-gray-900 dark:text-white text-xs mb-1 truncate max-w-[150px]">{{ item.descripcion || 'Equipo' }}</p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 italic max-w-[150px] truncate" :title="item.problema">{{ item.problema }}</p>
                  </div>
                </td>
                <td class="px-5 py-4">
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center font-black text-gray-500 text-xs">
                      {{ item.nombreCliente?.charAt(0) }}
                    </div>
                    <div>
                      <p class="font-black text-gray-900 dark:text-white text-xs leading-tight">{{ item.nombreCliente }}</p>
                      <p class="text-[10px] font-black text-gray-400 uppercase tracking-widest">{{ item.documentoCliente || 'S/D' }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-5 py-4 whitespace-nowrap">
                  <p class="font-black text-gray-900 dark:text-white text-[10px] leading-none">{{ formatearFecha(item.fechaIngreso) }}</p>
                  <p class="text-[9px] text-gray-400 font-black uppercase">{{ formatearHora(item.fechaIngreso) }}</p>
                </td>
                <td class="px-5 py-4">
                  <div :class="getEstadoStyle(item.nombreEstado)" class="px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest text-center border shadow-sm inline-block">
                    {{ item.nombreEstado }}
                  </div>
                </td>
                <td class="px-5 py-4">
                  <span class="font-black text-gray-900 dark:text-white text-xs">${{ (item.montoDiagnostico || item.presupuesto || 0).toFixed(2) }}</span>
                </td>
                <td class="px-5 py-4">
                  <span :class="getClasificacionStyle(item.nombreEstado)" class="px-2 py-1 rounded-lg text-[9px] font-black uppercase tracking-widest text-center border shadow-sm inline-block">
                    {{ getClasificacion(item.nombreEstado) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Versión Mobile -->
        <div class="lg:hidden space-y-3 p-2">
          <div v-if="cargando" v-for="i in 3" :key="'load-mobile-'+i" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 animate-pulse">
            <div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full mb-2"></div>
            <div class="h-3 bg-gray-100 dark:bg-gray-700 rounded w-3/4"></div>
          </div>
          
          <div v-if="!cargando && diagnosticosFiltrados.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 text-center">
            <div class="flex flex-col items-center opacity-30 select-none">
              <Icon icon="mdi:database-off-outline" class="text-6xl mb-3" />
              <h4 class="text-lg font-black text-gray-400 tracking-widest">No hay diagnósticos</h4>
            </div>
          </div>
          
          <div v-for="item in paginatedDiagnosticos" :key="item.idRecepcionEquipo" 
               class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all">
            <div class="flex flex-wrap items-center justify-between gap-2 mb-3 pb-2 border-b border-gray-100 dark:border-gray-700">
              <div class="flex items-center gap-2">
                <span class="px-2.5 py-1 bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-lg font-black text-xs border border-yellow-100 dark:border-yellow-800">
                  #{{ item.numeroOrden }}
                </span>
                <div :class="getEstadoStyle(item.nombreEstado)" class="px-2 py-0.5 rounded-lg text-[8px] font-black uppercase tracking-widest border shadow-sm">
                  {{ item.nombreEstado }}
                </div>
              </div>
              <div class="text-[9px] text-gray-400 font-black">{{ formatearFecha(item.fechaIngreso) }}</div>
            </div>

            <div class="flex items-center gap-2 mb-2">
              <div class="w-7 h-7 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center font-black text-gray-500 text-xs flex-shrink-0">
                {{ item.nombreCliente?.charAt(0) }}
              </div>
              <div class="flex-1 min-w-0">
                <p class="font-black text-gray-900 dark:text-white text-xs leading-tight truncate">{{ item.nombreCliente }}</p>
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest">{{ item.documentoCliente || 'S/D' }}</p>
              </div>
            </div>

            <div class="mb-2 bg-gray-50 dark:bg-gray-900/30 rounded-xl p-2">
              <p class="font-black text-gray-900 dark:text-white text-xs truncate">{{ item.descripcion || 'Equipo' }}</p>
              <p class="text-[10px] text-gray-500 dark:text-gray-400 italic truncate">{{ item.problema }}</p>
            </div>

            <div class="flex items-center justify-between">
              <span class="font-black text-gray-900 dark:text-white text-xs">${{ (item.montoDiagnostico || item.presupuesto || 0).toFixed(2) }}</span>
              <span :class="getClasificacionStyle(item.nombreEstado)" class="px-2 py-0.5 rounded-lg text-[8px] font-black uppercase tracking-widest border shadow-sm">
                {{ getClasificacion(item.nombreEstado) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div v-if="diagnosticosFiltrados.length > 0" class="bg-gray-50/50 dark:bg-gray-800/50 px-3 sm:px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div class="text-[10px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest text-center sm:text-left">
            MOSTRANDO {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, diagnosticosFiltrados.length) }} DE {{ diagnosticosFiltrados.length }}
          </div>
          <div class="flex items-center gap-1 flex-wrap justify-center">
            <button @click="goToFirstPage" :disabled="currentPage === 1" :class="['p-1.5 rounded-lg border transition-all hidden sm:inline-flex', currentPage === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
              <Icon icon="mdi:chevron-double-left" class="text-base sm:text-lg" />
            </button>
            <button @click="currentPage = Math.max(currentPage - 1, 1)" :disabled="currentPage === 1" :class="['p-1.5 rounded-lg border transition-all', currentPage === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
              <Icon icon="mdi:chevron-left" class="text-base sm:text-2xl" />
            </button>
            <div class="hidden sm:flex items-center gap-0.5 sm:gap-1 mx-1 sm:mx-2">
              <button v-for="page in displayedPages" :key="page" @click="currentPage = page" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg text-[10px] sm:text-xs font-black transition-all flex items-center justify-center', currentPage === page ? 'bg-yellow-500 text-white shadow-md shadow-yellow-500/30' : 'text-gray-500 hover:bg-white dark:hover:bg-gray-700 border border-transparent hover:border-gray-200 dark:hover:border-gray-600']">
                {{ page }}
              </button>
            </div>
            <span class="sm:hidden text-xs font-black text-gray-600 dark:text-gray-300 px-2">{{ currentPage }} / {{ totalPages }}</span>
            <button @click="currentPage = Math.min(currentPage + 1, totalPages)" :disabled="currentPage === totalPages" :class="['p-1.5 rounded-lg border transition-all', currentPage === totalPages ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
              <Icon icon="mdi:chevron-right" class="text-base sm:text-2xl" />
            </button>
            <button @click="goToLastPage" :disabled="currentPage === totalPages" :class="['p-1.5 rounded-lg border transition-all hidden sm:inline-flex', currentPage === totalPages ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm']">
              <Icon icon="mdi:chevron-double-right" class="text-base sm:text-lg" />
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import * as api from '@/api/diagnosticoExpress.js';

let Chart = null;
try {
  const chartModule = require('chart.js');
  Chart = chartModule.Chart;
  if (Chart) {
    Chart.register(
      chartModule.BarController,
      chartModule.BarElement,
      chartModule.CategoryScale,
      chartModule.LinearScale,
      chartModule.DoughnutController,
      chartModule.ArcElement,
      chartModule.LineController,
      chartModule.PointElement,
      chartModule.LineElement,
      chartModule.Filler,
      chartModule.Legend,
      chartModule.Title,
      chartModule.Tooltip
    );
  }
} catch {
  console.warn('Chart.js no está instalado');
}

export default {
  name: 'DiagnosticoExpress',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      vistaActual: 'todos',
      diagnosticos: [],
      cargando: false,
      filtroBusqueda: '',
      filtroClasificacion: 'TODOS',
      
      currentPage: 1,
      itemsPerPage: 5,
      maxVisiblePages: 10,
      
      chartBar: null,
      chartDoughnut: null,
      chartLine: null,
      
      errorApi: null
    };
  },
  computed: {
    // COMPLETADO: reparado, imposible_reparar
    diagnosticosCompletados() {
      return this.diagnosticos.filter(d => {
        const estado = (d.nombreEstado || '').toLowerCase();
        return estado === 'reparado' || estado === 'imposible_reparar';
      }).length;
    },
    // EN PROCESO: pasado_a_reparacion, por_diagnosticar
    diagnosticosEnProceso() {
      return this.diagnosticos.filter(d => {
        const estado = (d.nombreEstado || '').toLowerCase();
        return estado === 'pasado_a_reparacion' || estado === 'por_diagnosticar';
      }).length;
    },
    // ENTREGADO: entregado
    diagnosticosEntregados() {
      return this.diagnosticos.filter(d => {
        const estado = (d.nombreEstado || '').toLowerCase();
        return estado === 'entregado';
      }).length;
    },
    totalMonto() {
      return this.diagnosticos.reduce((sum, d) => sum + (d.montoDiagnostico || d.presupuesto || 0), 0);
    },
    estadosResumen() {
      const estados = {};
      this.diagnosticos.forEach(d => {
        const estado = (d.nombreEstado || 'Sin estado').toLowerCase();
        if (!estados[estado]) {
          estados[estado] = { cantidad: 0, monto: 0 };
        }
        estados[estado].cantidad += 1;
        estados[estado].monto += (d.montoDiagnostico || d.presupuesto || 0);
      });
      
      return Object.keys(estados).map(key => ({
        estado: key,
        cantidad: estados[key].cantidad,
        monto: estados[key].monto,
        clasificacion: this.getClasificacion(key)
      })).sort((a, b) => b.cantidad - a.cantidad);
    },
    diagnosticosFiltrados() {
      let result = this.diagnosticos || [];
      
      if (this.filtroBusqueda && this.filtroBusqueda.trim() !== '') {
        const q = this.filtroBusqueda.toLowerCase().trim();
        result = result.filter(r => 
          r.numeroOrden?.toLowerCase().includes(q) ||
          r.nombreCliente?.toLowerCase().includes(q) ||
          r.documentoCliente?.toLowerCase().includes(q) ||
          r.descripcion?.toLowerCase().includes(q) ||
          r.problema?.toLowerCase().includes(q) ||
          r.nombreEstado?.toLowerCase().includes(q)
        );
      }
      
      if (this.filtroClasificacion === 'COMPLETADO') {
        result = result.filter(r => {
          const estado = (r.nombreEstado || '').toLowerCase();
          return estado === 'reparado' || estado === 'imposible_reparar';
        });
      } else if (this.filtroClasificacion === 'EN_PROCESO') {
        result = result.filter(r => {
          const estado = (r.nombreEstado || '').toLowerCase();
          return estado === 'pasado_a_reparacion' || estado === 'por_diagnosticar';
        });
      } else if (this.filtroClasificacion === 'ENTREGADO') {
        result = result.filter(r => {
          const estado = (r.nombreEstado || '').toLowerCase();
          return estado === 'entregado';
        });
      }
      
      return result;
    },
    totalPages() {
      return Math.ceil(this.diagnosticosFiltrados.length / this.itemsPerPage);
    },
    paginatedDiagnosticos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.diagnosticosFiltrados.slice(start, end);
    },
    displayedPages() {
      const total = this.totalPages;
      const max = this.maxVisiblePages;
      const current = this.currentPage;
      
      if (total <= max) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(max / 2));
      let end = start + max - 1;
      
      if (end > total) {
        end = total;
        start = Math.max(1, end - max + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  mounted() {
    console.log('🚀 DiagnosticoExpress montado');
    this.cargarSegunVista();
  },
  watch: {
    vistaActual(newVal) {
      console.log('📋 Cambiando vista a:', newVal);
      this.currentPage = 1;
      this.cargarSegunVista();
    }
  },
  methods: {
    goToFirstPage() {
      this.currentPage = 1;
    },
    goToLastPage() {
      this.currentPage = this.totalPages;
    },

    formatearFecha(fecha) {
      if (!fecha) return '---';
      try {
        return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
      } catch {
        return '---';
      }
    },
    formatearHora(fecha) {
      if (!fecha) return '';
      try {
        return new Date(fecha).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      } catch {
        return '';
      }
    },

    getClasificacion(estado) {
      if (!estado) return 'DESCONOCIDO';
      const e = estado.toLowerCase();
      if (e === 'reparado' || e === 'imposible_reparar') {
        return 'COMPLETADO';
      }
      if (e === 'pasado_a_reparacion' || e === 'por_diagnosticar') {
        return 'EN PROCESO';
      }
      if (e === 'entregado') {
        return 'ENTREGADO';
      }
      return 'OTRO';
    },

    getClasificacionStyle(estado) {
      const clasificacion = this.getClasificacion(estado);
      if (clasificacion === 'COMPLETADO') {
        return 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800';
      }
      if (clasificacion === 'EN PROCESO') {
        return 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800';
      }
      if (clasificacion === 'ENTREGADO') {
        return 'bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800';
      }
      return 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-900/30 dark:text-gray-300 dark:border-gray-800';
    },

    getEstadoStyle(estado) {
      if (!estado) return 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-900/40 dark:text-gray-300 dark:border-gray-800';
      const e = estado.toLowerCase();
      if (e === 'reparado') return 'bg-green-500 text-white border-green-600 shadow-sm font-black';
      if (e === 'imposible_reparar') return 'bg-red-500 text-white border-red-600 shadow-sm font-black';
      if (e === 'entregado') return 'bg-purple-500 text-white border-purple-600 shadow-sm font-black';
      if (e === 'por_diagnosticar') return 'bg-yellow-500 text-white border-yellow-600 shadow-sm font-black';
      if (e === 'pasado_a_reparacion') return 'bg-blue-500 text-white border-blue-600 shadow-sm font-black';
      return 'bg-gray-500 text-white border-gray-600 shadow-sm font-black';
    },

    cargarSegunVista() {
      console.log('🔄 Cargando vista:', this.vistaActual);
      switch (this.vistaActual) {
        case 'todos':
          this.cargarTodos();
          break;
        case 'hoy':
          this.cargarHoy();
          break;
        case 'semanal':
          this.cargarSemanal();
          break;
        case 'mensual':
          this.cargarMensual();
          break;
        case 'estadisticas':
          this.cargarTodos();
          break;
        default:
          this.cargarTodos();
      }
    },

    // ============ ENDPOINTS ============

    async cargarTodos() {
      console.log('📥 Cargando TODOS los diagnósticos EXPRESS');
      this.cargando = true;
      this.errorApi = null;
      try {
        const res = await api.obtenerTodosDiagnosticosExpress();
        console.log('📥 Respuesta TODOS:', res);
        
        if (res.success && res.data) {
          this.diagnosticos = res.data.diagnosticos || res.data || [];
          console.log('✅ Diagnósticos cargados:', this.diagnosticos.length);
          
          if (this.vistaActual === 'estadisticas' && this.diagnosticos.length > 0) {
            this.$nextTick(() => this.crearGraficos());
          }
          
          if (this.diagnosticos.length === 0) {
            this.toast.info('No hay diagnósticos EXPRESS registrados');
          }
        } else {
          this.errorApi = res.error || 'Error al cargar datos';
          this.toast.error(this.errorApi);
        }
      } catch (error) {
        console.error('❌ Error cargando todos:', error);
        this.errorApi = error.message;
        this.toast.error('Error al cargar los diagnósticos: ' + error.message);
      } finally {
        this.cargando = false;
      }
    },

    async cargarHoy() {
      console.log('📥 Cargando diagnósticos de HOY');
      this.cargando = true;
      this.errorApi = null;
      try {
        const hoy = new Date();
        const fechaInicio = hoy.toISOString().split('T')[0];
        const fechaFin = hoy.toISOString().split('T')[0];
        
        console.log('📅 Fechas:', fechaInicio, fechaFin);
        
        const res = await api.obtenerDiagnosticosExpressPorFechas(fechaInicio, fechaFin);
        console.log('📥 Respuesta HOY:', res);
        
        if (res.success && res.data) {
          this.diagnosticos = res.data.diagnosticos || res.data || [];
          console.log('✅ Diagnósticos de hoy cargados:', this.diagnosticos.length);
          
          if (this.diagnosticos.length === 0) {
            this.toast.info('No hay diagnósticos EXPRESS para hoy');
          } else {
            this.toast.success(`Mostrando ${this.diagnosticos.length} diagnósticos de hoy`);
          }
        } else {
          this.errorApi = res.error || 'Error al cargar datos';
          this.toast.error(this.errorApi);
        }
      } catch (error) {
        console.error('❌ Error cargando hoy:', error);
        this.errorApi = error.message;
        this.toast.error('Error al cargar diagnósticos de hoy: ' + error.message);
      } finally {
        this.cargando = false;
      }
    },

    async cargarSemanal() {
      console.log('📥 Cargando diagnósticos SEMANALES');
      this.cargando = true;
      this.errorApi = null;
      try {
        const res = await api.obtenerDiagnosticosExpressSemanal();
        console.log('📥 Respuesta SEMANAL:', res);
        
        if (res.success && res.data) {
          this.diagnosticos = res.data.diagnosticos || res.data || [];
          console.log('✅ Diagnósticos semanales cargados:', this.diagnosticos.length);
        } else {
          this.errorApi = res.error || 'Error al cargar datos';
          this.toast.error(this.errorApi);
        }
      } catch (error) {
        console.error('❌ Error cargando semanal:', error);
        this.errorApi = error.message;
        this.toast.error('Error al cargar diagnósticos semanales: ' + error.message);
      } finally {
        this.cargando = false;
      }
    },

    async cargarMensual() {
      console.log('📥 Cargando diagnósticos MENSUALES');
      this.cargando = true;
      this.errorApi = null;
      try {
        const res = await api.obtenerDiagnosticosExpressMensual();
        console.log('📥 Respuesta MENSUAL:', res);
        
        if (res.success && res.data) {
          this.diagnosticos = res.data.diagnosticos || res.data || [];
          console.log('✅ Diagnósticos mensuales cargados:', this.diagnosticos.length);
        } else {
          this.errorApi = res.error || 'Error al cargar datos';
          this.toast.error(this.errorApi);
        }
      } catch (error) {
        console.error('❌ Error cargando mensual:', error);
        this.errorApi = error.message;
        this.toast.error('Error al cargar diagnósticos mensuales: ' + error.message);
      } finally {
        this.cargando = false;
      }
    },

    // ============ GRÁFICOS ============

    crearGraficos() {
      console.log('🎨 Creando gráficos...');
      
      if (!Chart) {
        console.warn('⚠️ Chart.js no disponible');
        this.toast.warning('Chart.js no está instalado. Los gráficos no se mostrarán.');
        return;
      }
      
      this.destruirGraficos();
      
      const diagnosticos = this.diagnosticos || [];
      console.log('📊 Datos para gráficos:', diagnosticos.length);
      
      if (diagnosticos.length === 0) {
        console.warn('⚠️ No hay datos para gráficos');
        this.toast.info('No hay datos suficientes para mostrar gráficos');
        return;
      }
      
      // ========== GRÁFICO DE BARRAS ==========
      const estadosCount = {};
      diagnosticos.forEach(d => {
        const estado = (d.nombreEstado || 'Sin estado').toLowerCase();
        estadosCount[estado] = (estadosCount[estado] || 0) + 1;
      });
      
      const estadosOrdenados = Object.keys(estadosCount).sort();
      const counts = estadosOrdenados.map(e => estadosCount[e]);
      const colores = estadosOrdenados.map(e => {
        if (e === 'reparado') return 'rgba(34, 197, 94, 0.7)';
        if (e === 'imposible_reparar') return 'rgba(239, 68, 68, 0.7)';
        if (e === 'entregado') return 'rgba(168, 85, 247, 0.7)';
        if (e === 'por_diagnosticar') return 'rgba(234, 179, 8, 0.7)';
        if (e === 'pasado_a_reparacion') return 'rgba(59, 130, 246, 0.7)';
        return 'rgba(107, 114, 128, 0.7)';
      });
      const bordes = colores.map(c => c.replace('0.7', '1'));
      
      const ctxBar = this.$refs.chartBarRef?.getContext('2d');
      if (ctxBar) {
        try {
          this.chartBar = new Chart(ctxBar, {
            type: 'bar',
            data: {
              labels: estadosOrdenados.map(e => e.toUpperCase()),
              datasets: [{
                label: 'Cantidad',
                data: counts,
                backgroundColor: colores,
                borderColor: bordes,
                borderWidth: 2,
                borderRadius: 6
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: { stepSize: 1 }
                }
              }
            }
          });
          console.log('✅ Gráfico de barras creado');
        } catch (error) {
          console.error('❌ Error creando gráfico de barras:', error);
        }
      }

      // ========== GRÁFICO DE DONA ==========
      const ctxDoughnut = this.$refs.chartDoughnutRef?.getContext('2d');
      if (ctxDoughnut) {
        try {
          const completados = this.diagnosticosCompletados;
          const enProceso = this.diagnosticosEnProceso;
          const entregados = this.diagnosticosEntregados;
          
          // Para la dona mostramos 3 categorías: Completados, En Proceso, Entregados
          console.log('📊 Distribución:', { completados, enProceso, entregados });
          
          this.chartDoughnut = new Chart(ctxDoughnut, {
            type: 'doughnut',
            data: {
              labels: ['Completados', 'En Proceso', 'Entregados'],
              datasets: [{
                data: [completados || 1, enProceso || 1, entregados || 1],
                backgroundColor: ['#22c55e', '#3b82f6', '#a855f7'],
                borderWidth: 0
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: {
                    font: { weight: 'bold', size: 11 },
                    padding: 15
                  }
                }
              },
              cutout: '60%'
            }
          });
          console.log('✅ Gráfico de dona creado');
        } catch (error) {
          console.error('❌ Error creando gráfico de dona:', error);
        }
      }

      // ========== GRÁFICO DE LÍNEAS ==========
      const fechas = {};
      diagnosticos.forEach(d => {
        const fecha = d.fechaIngreso ? new Date(d.fechaIngreso).toLocaleDateString('es-ES') : 'Sin fecha';
        if (!fechas[fecha]) {
          fechas[fecha] = 0;
        }
        fechas[fecha] += (d.montoDiagnostico || d.presupuesto || 0);
      });
      
      const fechasOrdenadas = Object.keys(fechas).sort((a, b) => {
        try {
          const [da, ma, aa] = a.split('/');
          const [db, mb, ab] = b.split('/');
          return new Date(aa, ma-1, da) - new Date(ab, mb-1, db);
        } catch {
          return 0;
        }
      });
      
      const montos = fechasOrdenadas.map(f => fechas[f]);
      
      const ctxLine = this.$refs.chartLineRef?.getContext('2d');
      if (ctxLine) {
        try {
          this.chartLine = new Chart(ctxLine, {
            type: 'line',
            data: {
              labels: fechasOrdenadas.length > 0 ? fechasOrdenadas : ['Sin datos'],
              datasets: [{
                label: 'Monto Total ($)',
                data: montos.length > 0 ? montos : [0],
                borderColor: 'rgb(139, 92, 246)',
                backgroundColor: 'rgba(139, 92, 246, 0.1)',
                fill: true,
                tension: 0.4,
                pointBackgroundColor: 'rgb(139, 92, 246)',
                pointRadius: 5,
                borderWidth: 3
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => '$' + value.toFixed(0)
                  }
                }
              }
            }
          });
          console.log('✅ Gráfico de líneas creado');
        } catch (error) {
          console.error('❌ Error creando gráfico de líneas:', error);
        }
      }
    },

    destruirGraficos() {
      console.log('🗑️ Destruyendo gráficos...');
      if (this.chartBar) {
        this.chartBar.destroy();
        this.chartBar = null;
      }
      if (this.chartDoughnut) {
        this.chartDoughnut.destroy();
        this.chartDoughnut = null;
      }
      if (this.chartLine) {
        this.chartLine.destroy();
        this.chartLine = null;
      }
    }
  },
  beforeDestroy() {
    this.destruirGraficos();
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
.custom-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 10px;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

@media (min-width: 640px) {
  .btn {
    padding: 8px 16px;
    font-size: 11px;
  }
}

.btn-primary-yellow {
  background: #eab308;
  color: white;
}

.btn-primary-yellow:hover {
  background: #ca8a04;
}

.btn-outline-yellow {
  background: transparent;
  border: 1.5px solid #eab308;
  color: #eab308;
}

.btn-outline-yellow:hover {
  background: #eab308;
  color: white;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }
</style>